// 新版本提示：不自動重新整理（會中斷作答、打到一半的字），改成畫面上方出現提示，使用者按了才更新。
// 新版 service worker 下載好、或載入某個頁面的檔案時發現已被新版取代，都會呼叫 announceUpdate。
import React, { useEffect, useState } from 'react';

const EVENT = 'gsat-update-ready';
let pending: (() => void) | null = null;   // 使用者按「立即更新」時要做的事；null 表示沒有新版本
let dismissed = false;

export function announceUpdate(apply: () => void) {
  pending = apply;
  window.dispatchEvent(new Event(EVENT));
}
export const hasPendingUpdate = () => pending !== null;

// 某個頁面的檔案已被新版取代時，顯示在原本頁面位置的替代內容（不自動重載）
export function StaleChunkNotice() {
  return (
    <div style={{ maxWidth: 360, margin: '60px auto', padding: 20, textAlign: 'center', color: 'var(--text)' }}>
      <div style={{ fontSize: 40, marginBottom: 8 }}>🆕</div>
      <p style={{ fontSize: 15, lineHeight: 1.6, margin: '0 0 14px' }}>App 已經有新版本，需要更新後才能開啟這個頁面。</p>
      <button onClick={() => (pending ?? (() => window.location.reload()))()}
        style={{ padding: '10px 22px', borderRadius: 10, border: 'none', background: 'var(--accent)', color: '#fff', fontSize: 15, fontWeight: 700, cursor: 'pointer' }}>立即更新</button>
    </div>
  );
}

export default function UpdateBanner() {
  const [show, setShow] = useState(() => hasPendingUpdate() && !dismissed);
  useEffect(() => {
    const h = () => { dismissed = false; setShow(true); };
    window.addEventListener(EVENT, h);
    return () => window.removeEventListener(EVENT, h);
  }, []);
  if (!show) return null;
  return (
    <div role="status" style={{ position: 'fixed', top: 'calc(8px + env(safe-area-inset-top, 0px))', left: 8, right: 8, zIndex: 10002, display: 'flex', justifyContent: 'center', pointerEvents: 'none' }}>
      <div style={{ pointerEvents: 'auto', maxWidth: 480, width: '100%', display: 'flex', alignItems: 'center', gap: 8, background: '#1e293b', color: '#fff', borderRadius: 12, padding: '10px 12px', boxShadow: '0 6px 24px rgba(0,0,0,.3)', fontSize: 13, lineHeight: 1.4 }}>
        <span style={{ fontSize: 18 }}>🆕</span>
        <span style={{ flex: 1, minWidth: 0 }}>有新版本。更新會重新載入頁面，建議先做完手邊的題目。</span>
        <button onClick={() => pending?.()} style={{ padding: '6px 12px', borderRadius: 8, border: 'none', background: 'var(--accent, #6366f1)', color: '#fff', fontWeight: 700, fontSize: 13, cursor: 'pointer', flexShrink: 0 }}>立即更新</button>
        <button onClick={() => { dismissed = true; setShow(false); }} aria-label="稍後再說" style={{ background: 'none', border: 'none', color: '#cbd5e1', fontSize: 16, cursor: 'pointer', padding: '2px 4px', flexShrink: 0 }}>✕</button>
      </div>
    </div>
  );
}
